import React from "react";
import { Box, Flex, Progress, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { getPasswordStrength } from "utils/passwordUtils";

const PasswordStrengthBar = ({ password }) => {
  const { t } = useTranslation();
  const strength = getPasswordStrength(password);

  // Don't show anything when password is empty - better UX
  const isPasswordEmpty = strength.level === "empty";

  const labels = {
    very_weak: t("password.strength.very_weak", { defaultValue: "Very weak" }),
    weak: t("password.strength.weak", { defaultValue: "Weak" }),
    medium: t("password.strength.medium", { defaultValue: "Medium" }),
    strong: t("password.strength.strong", { defaultValue: "Strong" }),
    very_strong: t("password.strength.very_strong", { defaultValue: "Very strong" })
  };

  return (
    <Box mt={2}>
      <Flex align="center" justify="flex-end" mb={1} minH="4">
        {!isPasswordEmpty && (
          <Text fontSize="xs" color="gray.300" fontWeight="semibold">
            {labels[strength.level]}
          </Text>
        )}
      </Flex>
      <Progress
        value={strength.percent}
        size="xs"
        borderRadius="full"
        bg="rgba(255,255,255,0.1)"
        colorScheme={strength.colorScheme}
      />
    </Box>
  );
};

export default PasswordStrengthBar;
